import sdk from 'amplitude-js';
import Provider from './provider';
import store from '../store/userAttributes';

export default class Amplitude extends Provider {
  constructor() {
    super();
    if (!window.amplitude) {
      window.amplitude = sdk.getInstance();
      window.amplitude.init(process.env.AMPLITUDE_KEY || null);
    }

    if (typeof (window.amplitude) !== 'object') {
      throw new Error('[amplitude] load issue.');
    }
  }

  trackEvent = (event, args, userProperties = {}) => {
    const storeUserProperties = store.currentUser();
    if (event === 'login_request') {
      setTimeout(() => {
        window.amplitude.setUserId(store.currentUser().user_id);
      }, 800);
    }

    if (Object.keys(storeUserProperties.user_id).length > 0) {
      window.amplitude.setUserProperties(storeUserProperties);
    }
    if (Object.keys(userProperties).length > 0) {
      window.amplitude.setUserProperties(userProperties);
    }
    if (Object.keys(args).length > 0) window.amplitude.logEvent(event, args);
    else window.amplitude.logEvent(event);
  }
}
